import { createNurseWorkload } from './createNurseWorkload'
import { createTemplateCompliance } from './createTemplateCompliance'
import { createTreatmentVariance } from './createTreatmentVariance'
import { createCompletedVolumes } from './createCompletedVolumes'
import { createPatientWait } from './createPatientWait'
import { createChairTimeUtilization } from './createChairTimeUtilization'
import { createPatientPunctuality } from './createPatientPunctuality'
import { createAddOnCancellations } from './createAddOnCancellations'
import { createPatientAcuity } from './createPatientAcuity'
import { calculateProcessMetrics } from './calculateProcessMetrics'

// This file exports all graph calculation functions to make imports cleaner
export {
  createNurseWorkload,
  createTemplateCompliance,
  createTreatmentVariance,
  createCompletedVolumes,
  createPatientWait,
  createChairTimeUtilization,
  createPatientPunctuality,
  createAddOnCancellations,
  createPatientAcuity,
  calculateProcessMetrics
}

/**
 * Helper function to easily create a BlankCard component with appropriate data
 * @param {string} graphType - The type of graph to render (e.g., 'nurseWorkload')
 * @param {Object} data - The data for the graph
 * @param {Object} options - Additional options for the graph
 * @returns {Object} - Props object ready to spread into a BlankCard component
 */
export const createGraphProps = (graphType, data, options = {}, viewState, setViewState, settings) => {

  switch (graphType) {
    case 'nurseWorkload':
      return createNurseWorkload(data, options)
    case 'templateCompliance':
      return createTemplateCompliance(data, options)  
    case 'treatmentVariance':
      return createTreatmentVariance(data, options)
    case 'completedVolumes':
      return createCompletedVolumes(data, options, viewState, setViewState)
    case 'patientWait':
      return createPatientWait(data, options, viewState, setViewState)
    case 'chairTimeUtilization':
      return createChairTimeUtilization(data, options, viewState, setViewState)
    case 'patientPunctuality':
      return createPatientPunctuality(data, options, settings)
    case 'addOnCancellations':
      return createAddOnCancellations(data, options)
    case 'patientAcuity':
      return createPatientAcuity(data, options)
    // Add more cases for other graph types here
    default:
      throw new Error(`Unknown graph type: ${graphType}`)
  }
}

const graphCalculations = {
  createNurseWorkload,
  createTemplateCompliance,
  createTreatmentVariance,
  createCompletedVolumes,
  createPatientWait,
  createChairTimeUtilization,
  createPatientPunctuality,
  createAddOnCancellations,
  createPatientAcuity,
  calculateProcessMetrics,
  createGraphProps
}

export default graphCalculations
